.k{align-items:center;}